import axios from "axios"
import { API_BASE } from "../../../config/appConfig"

function buildAuthConfig(extra = {}, clinicIdOverride = undefined) {
  const token = localStorage.getItem("odontoflow_token") || ""
  const storedClinicId = localStorage.getItem("odontoflow_clinic_id") || ""

  const effectiveClinicId =
    clinicIdOverride !== undefined ? clinicIdOverride : storedClinicId

  const headers = {
    ...(extra.headers || {})
  }

  if (token) {
    headers.Authorization = `Bearer ${token}`
  }

  // solo enviar header si hay clínica específica
  if (effectiveClinicId && effectiveClinicId !== "ALL") {
    headers["x-clinic-id"] = effectiveClinicId
  }

  return {
    ...extra,
    headers
  }
}

export async function getClinicStatus(clinicId) {
  if (!clinicId || clinicId === "ALL") {
    return null
  }

  const { data } = await axios.get(
    `${API_BASE}/subscriptions/clinic-status`,
    {
      ...buildAuthConfig({}, clinicId),
      params: { clinicId }
    }
  )

  return data
}

export async function getPublicPlans() {
  const { data } = await axios.get(`${API_BASE}/subscriptions/plans`)
  return Array.isArray(data) ? data : []
}

export async function upgradeClinicPlan(payload) {
  const clinicId = payload?.clinicId || undefined

  const { data } = await axios.post(
    `${API_BASE}/subscriptions/upgrade`,
    payload,
    buildAuthConfig({}, clinicId)
  )

  return data
}